
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
// import {
//   getMonitorGunStatus,
//   getMonitorPileGrid
// } from "@/api/api-operation-service";

@Component({
  components: {}
})
export default class PiSiteMonitor extends Vue {
  @Prop()
  chartData!: objAny;

  @Prop()
  second!: number;

  @Watch("chartData", { immediate: true, deep: true })
  "watch.chartData"(newVal: objAny) {
    if (!newVal || newVal.length === 0) {
      return;
    }
    this.echartsOption.legend.data = newVal.map((item: objAny) => {
      return item.name;
    });
    this.echartsOption.series.splice(0);
    this.echartsOption.series = newVal.map((item: objAny) => {
      const cItem = {
        name: item.name,
        type: "line",
        data: item.data,
        itemStyle: {
          color: item.color
        }
      };
      return cItem;
    });
  }

  echartsOption = {
    title: {
      show: true
    },
    tooltip: {
      trigger: "axis",
      formatter: (params: objAny) => {
        let html = "";
        html += params[0].value[0];
        for (const i in params) {
          html +=
            "<div>" +
            params[i].marker +
            params[i].seriesName +
            ":" +
            params[i].value[1] +
            "</div>";
        }
        return html;
      }
    },
    legend: {
      show: true,
      type: "plain",
      orient: "horizontal",
      top: "bottom",
      right: "center",
      itemWidth: 20,
      itemHeight: 10,
      // selectedMode: false,
      data: []
    },
    xAxis: {
      type: "time",
      axisLine: {
        lineStyle: {
          color: "#999"
        }
      },
      splitLine: {
        lineStyle: {
          // 使用深浅的间隔色
          color: "#e5e5e5"
        }
      },
      axisLabel: {
        formatter: (value: number) => {
          return this["$common"].userDate(value, "HH:MM:SS");
        }
      },
      interval: this.second * 1000
    },
    yAxis: {
      type: "value",
      name: "",
      splitLine: {
        lineStyle: {
          type: "solid",
          color: "#F7F7F7"
        }
      },
      axisLine: {
        lineStyle: {
          color: "#999"
        }
      }
    },
    series: []
  };
  private piEchart: objAny = {};
  private myChart: objAny = {};
  private win: objAny = window;
  private init() {
    this.myChart = this.win.echarts.init(this.piEchart);
    this.myChart.clear();

    this.myChart.setOption(this.echartsOption, true);
  }
  mounted() {
    this.$nextTick(() => {
      this.piEchart = this.$refs["echartLine"];
      this.init();
    });
  }
}
